import { render, staticRenderFns } from "./sentgift.vue?vue&type=template&id=61b457f2&scoped=true&"
import script from "./sentgift.vue?vue&type=script&lang=js&"
export * from "./sentgift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b457f2",
  null
  
)

export default component.exports